import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axiosInstance from '../AxiosInstance';
import { Toast, Field, PageHeader, LoadingSpinner } from './v2-utils';
import '../styles/v2.css';

export default function EditSupplierV2() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [sourceType, setSourceType] = useState('supplier');
  const [name, setName]             = useState('');
  const [contact, setContact]       = useState('');
  const [location, setLocation]     = useState('');
  const [loading, setLoading]       = useState(true);
  const [saving, setSaving]         = useState(false);
  const [toast, setToast]           = useState(null);

  useEffect(() => {
    axiosInstance.get(`/suppliers/${id}`)
      .then(r => {
        const s = r.data;
        const isMarket = !!s.market_name;
        setSourceType(isMarket ? 'market' : 'supplier');
        setName(isMarket ? (s.market_name || '') : (s.name || s.supplier_name || ''));
        setContact(s.contact_info || s.phone_number || '');
        setLocation(s.location || '');
      })
      .catch(() => setToast({ message: 'Failed to load supplier data.', severity: 'error' }))
      .finally(() => setLoading(false));
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await axiosInstance.put(`/suppliers/${id}`, {
        source_type: sourceType,
        supplier_name: sourceType === 'supplier' ? name : null,
        market_name:   sourceType === 'market'   ? name : null,
        contact_info: contact,
        location,
      });
      setToast({ message: 'Supplier updated successfully!', severity: 'success' });
      setTimeout(() => navigate('/new/dashboard/suppliers/view'), 1000);
    } catch {
      setToast({ message: 'Failed to update supplier.', severity: 'error' });
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <LoadingSpinner message="Loading supplier…" />;

  return (
    <div style={{ maxWidth: 620, margin: '0 auto' }}>
      <PageHeader title="Edit Supplier" onBack={() => navigate('/new/dashboard/suppliers/view')} />
      <form onSubmit={handleSubmit}>
        <div className="v2-card" style={{ padding: 24, display: 'flex', flexDirection: 'column', gap: 20 }}>
          <p style={{ fontSize: 11, fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.08em', margin: 0 }}>Supplier Details</p>

          <Field label="Type">
            <div style={{ display: 'flex', gap: 10 }}>
              {['supplier', 'market'].map(t => (
                <button key={t} type="button" onClick={() => setSourceType(t)}
                  style={{ flex: 1, padding: '10px 0', borderRadius: 10, border: `1.5px solid ${sourceType === t ? '#10b981' : '#e2e8f0'}`, background: sourceType === t ? '#f0fdf4' : 'white', color: sourceType === t ? '#065f46' : '#475569', fontSize: 13, fontWeight: 700, cursor: 'pointer', textTransform: 'capitalize' }}>
                  {t === 'supplier' ? 'Supplier' : 'Market'}
                </button>
              ))}
            </div>
          </Field>

          <Field label={sourceType === 'supplier' ? 'Supplier Name *' : 'Market Name *'}>
            <input className="v2-input" type="text" value={name} onChange={e => setName(e.target.value)} required />
          </Field>

          <Field label="Phone Number" hint="Used for WhatsApp reorder messages (optional)">
            <input className="v2-input" type="tel" value={contact} onChange={e => setContact(e.target.value)} />
          </Field>

          <Field label="Location *">
            <input className="v2-input" type="text" value={location} onChange={e => setLocation(e.target.value)} required />
          </Field>

          <button type="submit" className="v2-btn-submit" disabled={saving} style={{ fontSize: 15 }}>
            {saving ? 'Saving…' : 'Save Changes'}
          </button>
        </div>
      </form>
      {toast && <Toast {...toast} onClose={() => setToast(null)} />}
    </div>
  );
}
